import { z } from "zod/v4";

/**
 * Public support-form submission. Shared by the web form and the server
 * handler. `website` is a honeypot — real users never see or fill it; a
 * non-empty value marks a bot and the submission is silently dropped.
 * `turnstileToken` is the Cloudflare Turnstile response token, verified
 * server-side before any email is sent.
 */
export const supportSubmissionSchema = z.object({
  name: z.string().trim().min(1).max(100),
  email: z.string().trim().email().max(254),
  subject: z.string().trim().min(1).max(150),
  message: z.string().trim().min(1).max(4000),
  website: z.string().max(200).optional(),
  turnstileToken: z.string().min(1),
});

export type SupportSubmission = z.infer<typeof supportSubmissionSchema>;
